import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-criminal-sub-category',
  templateUrl: './criminal-sub-category.component.html',
  styleUrls: ['./criminal-sub-category.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class CriminalSubCategoryComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
